/**
 * Strip markdown enough for TTS (same spirit as backend `normalizeTtsTextForSpeech`, lighter).
 */
export function stripMarkdownForTts(markdown: string): string {
  let text = markdown;
  // Remove code blocks and links first.
  text = text.replace(/```[\s\S]*?```/g, " ");
  text = text.replace(/`([^`]+)`/g, "$1");
  text = text.replace(/!\[[^\]]*]\([^)]+\)/g, " ");
  text = text.replace(/\[([^\]]+)\]\((?:https?:\/\/|www\.)[^)\s]+\)/gi, "$1");
  text = text.replace(/\[[^\]]*]\([^)]+\)/g, " ");
  text = text.replace(/<((?:https?:\/\/|www\.)[^>\s]+)>/gi, " link ");
  text = text.replace(/\bhttps?:\/\/[^\s)]+/gi, " link ");
  text = text.replace(/\bwww\.[^\s)]+/gi, " link ");

  // Match realtime TTS normalization: strip emojis/pictographs and emoji joiners/selectors.
  text = text.replace(/\p{Extended_Pictographic}/gu, "");
  text = text.replace(/[\u{1F1E6}-\u{1F1FF}]{2}/gu, "");
  text = text.replace(/\u200d/g, "");
  text = text.replace(/[\ufe0f\ufe0e]/g, "");

  // Remove common markdown/list artifacts.
  text = text.replace(/[`*_#>~]/g, "");
  text = text.replace(/^\s*[-*•]\s+/gm, "");
  text = text.replace(/^\s*\d+\s*[.)]\s+/gm, "");

  // Preserve heading/list boundaries as sentence breaks.
  text = text.replace(/^\s{0,3}#{1,6}\s+/gm, ". ");
  text = text.replace(/[:;]{2,}/g, ", ");
  text = text.replace(/\s+([.!?…]+)/g, "$1");
  text = text.replace(/([.!?…])(?=[A-Za-z])/g, "$1 ");
  text = text.replace(/\n+/g, ". ");
  text = text.replace(/\s{2,}/g, " ");
  text = text.replace(/^[.!?…,;:\s]+/, "");
  return text.trim();
}
